/** Layout presets for ResponsiveImage (widths for srcSet + default sizes). */
export const RESPONSIVE_IMAGE_VARIANTS = {
  thumbnail: {
    widths: [96, 160, 240],
    sizes: '80px'
  },
  card: {
    widths: [360, 540, 720, 960],
    sizes: '(max-width: 768px) 100vw, min(440px, 42vw)'
  },
  cover: {
    widths: [720, 960, 1280, 1600],
    sizes: '(max-width: 768px) 100vw, (max-width: 1280px) 70vw, min(960px, 55vw)'
  },
  gallery: {
    widths: [800, 1200, 1600],
    sizes: '(max-width: 768px) 100vw, min(90vw, 1200px)'
  },
  hero: {
    widths: [640, 960, 1280, 1920],
    sizes: '100vw'
  },
  side: {
    widths: [400, 560, 720, 960],
    sizes: '(max-width: 1536px) 32vw, 420px'
  },
  highlight: {
    widths: [200, 280, 400],
    sizes: '130px'
  },
  founderSquare: {
    widths: [360, 480, 640, 800],
    sizes: '(max-width: 768px) 85vw, min(300px, 40vw)'
  },
  spotlightCard: {
    widths: [360, 540, 720],
    sizes: '290px'
  },
  thumb48: {
    widths: [72, 96, 128],
    sizes: '48px'
  },
  thumb64: {
    widths: [96, 128, 160],
    sizes: '64px'
  },
  thumb80: {
    widths: [120, 160, 240],
    sizes: '80px'
  },
  thumb96: {
    widths: [120, 160, 192, 240],
    sizes: '96px'
  }
};
